import { useEffect, useMemo, useState } from "react";
import PUB from "@/data/pub.json";
import { api } from "@/lib/api";
import { Fichas } from "./Fichas";
import { Charlas } from "./Charlas";

const LBL = { P: "Emociones positivas", E: "Compromiso", R: "Relaciones", M: "Significado", A: "Logros", GLOBAL: "Global PERMA", N: "Pens. negativos", SALUD: "Salud general", EST: "Estabilidad emocional" };

export const Bars = ({ data, keys, testid, labels = LBL }) => (
  <div className="perma" data-testid={testid}>
    {keys.map((k) => {
      const raw = data?.[k];
      const v = raw === "" || raw == null ? null : Number(raw);
      const ok = typeof v === "number" && !Number.isNaN(v);
      return (
        <div className="prow" key={k} data-testid={`${testid}-${k}`}>
          <span>{labels[k]}</span>
          <div className="pbar"><i className={k === "N" ? "w" : ""} style={{ width: ok ? `${v * 10}%` : 0 }}></i></div>
          <b>{ok ? v.toFixed(1) : "–"}</b>
        </div>
      );
    })}
  </div>
);

const initials = (n) => n.split(/\s+/).filter((w) => w.length > 2 || /^[A-Z]/.test(w)).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const FALLBACK = PUB.clubs.map(([deporte, nombre]) => ({ id: deporte + nombre, nombre, deporte, enlace: "", logo: "" }));

const ClubCard = ({ c, j }) => {
  const inner = (
    <>
      <span className="clogo" data-testid={`club-logo-${j}`}>
        {c.logo ? <img src={`${process.env.REACT_APP_BACKEND_URL}${c.logo}`} alt={`Logo de ${c.nombre}`} loading="lazy" /> : <span className="cmono" aria-hidden="true">{initials(c.nombre)}</span>}
      </span>
      <div><h4>{c.nombre}</h4><small>{c.deporte}</small></div>
    </>
  );
  return c.enlace
    ? <a className="ccard" href={c.enlace} target="_blank" rel="noopener noreferrer" data-testid={`club-card-${j}`}>{inner}</a>
    : <div className="ccard" data-testid={`club-card-${j}`}>{inner}</div>;
};

const Clubs = () => {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/aliados").then((r) => setList(r.data)).catch(() => setList(FALLBACK)); }, []);
  return (
    <div className="ccards" data-testid="clubs-list">
      {(list || FALLBACK).map((c, j) => <ClubCard key={c.id} c={c} j={j} />)}
    </div>
  );
};

export const Trabajo = () => (
  <section className="light" id="trabajo" data-testid="trabajo-section">
    <div className="wrap">
      <div className="head reveal"><h2>Clubes e instituciones que han trabajado con nosotros</h2></div>
      <Clubs />
    </div>
  </section>
);

const DEPS = Array.from(new Set(PUB.acts.flatMap((a) => a[1].split(" · ")))).sort();

export const Actividades = () => {
  const [q, setQ] = useState("");
  const [sel, setSel] = useState("");
  const list = useMemo(() => {
    const ql = q.toLowerCase();
    return PUB.acts.filter((a) => (!sel || a[1].includes(sel)) && a.join(" ").toLowerCase().includes(ql));
  }, [q, sel]);
  return (
    <section id="actividades" data-testid="actividades-section">
      <div className="wrap">
        <div className="head reveal"><h2>Actividades para entrenar la mente</h2><p className="lead" style={{ margin: 0 }}>Fichas interactivas para practicar en casa o en el entrenamiento: mira cómo se hace, practícala y registra cómo te fue. Tus respuestas ayudan al equipo de psicología a medir el avance.</p></div>
        <Fichas />
        <Charlas />
        <h3 style={{ marginTop: 40 }}>Biblioteca completa</h3>
        <input className="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar actividad, deporte o habilidad…" data-testid="actividades-search-input" />
        <div className="chips" data-testid="actividades-chips">
          {["Todas", ...DEPS].map((d, j) => (
            <button key={d} className="chip" aria-pressed={j === 0 ? !sel : sel === d} onClick={() => setSel(j === 0 ? "" : d)} data-testid={`actividades-chip-${d}`}>{d}</button>
          ))}
        </div>
        <div className="agrid" data-testid="actividades-grid">
          {list.length ? list.map((a) => (
            <div className="act" key={a[0] + a[1]} data-testid="actividad-card"><small>{a[1]} · {a[2]}</small><h4>{a[0]}</h4><p>{a[3]}</p></div>
          )) : <p data-testid="actividades-empty">No hay resultados.</p>}
        </div>
      </div>
    </section>
  );
};
